const config = require('../config')

const ensureBasePath = path => {
  if (path.startsWith(config.basePath)) {
    return path
  }
  if (!path.startsWith('/')) {
    throw new Error('Only works with absolute path (starts with /)')
  }
  return config.basePath + path
}

module.exports = ensureBasePath
